export default "__VITE_ASSET__Uvf$ocWF__"